<template>
  <div>
    <div class="overflow-x-auto">
      <div class="flex">
        <div class="flex grow items-center justify-between">
          <TabList
            :class="[
              'flex w-full justify-center border-neutral-200 text-lg',
              vertical
                ? 'flex-col border-r-2 border-b-0'
                : 'overflow-y-visible',
            ]"
          >
            <slot />
          </TabList>
        </div>
        <div v-if="$slots.after">
          <slot name="after" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { TabList } from '@headlessui/vue';

type Props = {
  vertical?: boolean;
};

withDefaults(defineProps<Props>(), {
  vertical: false,
});
</script>
